export { default } from './sorting-header';
export { default as schema } from './sorting-header.schema';
